import { render } from "./DataV310.vue?vue&type=template&id=1b2df794&scoped=true"
import script from "./DataV310.vue?vue&type=script&lang=js"
export * from "./DataV310.vue?vue&type=script&lang=js"

import "./DataV310.vue?vue&type=style&index=0&id=1b2df794&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2df794"]])

export default __exports__